import * as React from 'react';

export interface EditLinkProperties {
  readonly jump: Function | undefined;
  readonly step: number;
}

export class EditLink extends React.Component<EditLinkProperties> {
  render() {
    return (
      <a onClick={() => this.props.jump!(this.props.step)} className="active">
        <i className="fa fa-edit" />
      </a>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/wizard/_components/wizard-edit-link.component.tsx